import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { IPlacementDetails } from 'app/models/Placement/PlacementDetails';
import { useDispatch, useSelector } from 'react-redux';
import { selectPlacementDetails } from 'store/redux-store/placement-details/selectors';
import { selectedModForTask } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Cancel } from '@AMIEWEB/Common/CancelModal/Cancel';
import { ModsLinkTaskSearchWrapper } from './ModsLinkTaskSearchWrapper';
import { taskDetailsActions } from '@AMIEWEB/Tasks/store/Tasks.redux';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';

const useStyles = makeStyles()(() => ({
  dialogContainer: {
    minWidth: '94vw',
  },
  dialogContent: {
    padding: 0,
    overflowX: 'auto',
    overflowY: 'hidden',
  },
}));

export const LinkTaskForMods = ({
  openTaskGrid,
  setOpenTaskGrid,
  selectedRowDetails,
  setSelectedRowDetails,
}: {
  openTaskGrid: boolean;
  setOpenTaskGrid: any;
  selectedRowDetails: any;
  setSelectedRowDetails: any;
}) => {
  const { classes } = useStyles();
  const [openCancelModel, setCancelModalOpen] = useState(false);
  const dispatch = useDispatch();
  const foundPlacement: IPlacementDetails = useSelector(selectPlacementDetails);
  const selectedTask = useSelector(selectedModForTask);

  useEffect(() => {
    if (!openTaskGrid) {
      return undefined;
    }
    return () => {
      dispatch(taskDetailsActions.setTaskSearchData(null));
      dispatch(globalActions.closeBanner());
      dispatch(gridStateActions.setFiltersExpanded(false));
      dispatch(placementModsAction.setSelectedTaskForMod(null));
    };
  }, [dispatch, openTaskGrid]);

  const onSubmit = () => {
    dispatch(placementModsAction.setSelectedTaskForMod(null));
    const payload = {
      assignTaskId: selectedTask.taskId,
      assignRootTaskId: selectedTask.rootTaskId,
      placementId: foundPlacement?.header?.placementId,
      travelerOptionIds: selectedRowDetails?.map(val => val?.travelerOptionId),
    };
    dispatch(placementModsAction.updateLinkModTask(payload));
    setSelectedRowDetails([]);
    setOpenTaskGrid(false);
    dispatch(placementModsAction.setOpenTaskGrid(null));
  };

  const handleCancel = () => {
    if (selectedTask) {
      setCancelModalOpen(true);
    } else {
      onClose();
    }
  };

  const onClose = () => {
    dispatch(placementModsAction.setOpenTaskGrid(null));
    setOpenTaskGrid(false);
  };

  return (
    <>
      <GenericDialog
        variant={'blue'}
        classes={{ paper: classes.dialogContainer }}
        open={openTaskGrid}
        draggable
        disablePortal
        maxWidth="md"
        disableEscapeKeyDown
        onClose={handleCancel}
        dialogTitleProps={{
          text: `Link Task`,
          closeButton: true,
          expandable: true,
        }}
        dialogActions={[
          {
            onClick: handleCancel,
            text: 'CANCEL',
            variant: 'contained',
            color: 'tertiary',
          },
          {
            text: `SAVE`,
            variant: 'contained',
            type: 'submit',
            disabled: !selectedTask,
            onClick: onSubmit,
          },
        ]}
        dialogContentProps={{
          classes: { root: classes.dialogContent },
        }}
      >
        <ModsLinkTaskSearchWrapper foundPlacement={foundPlacement} isOpen={openTaskGrid} />
      </GenericDialog>
      <Cancel
        openDialog={openCancelModel}
        handleConfirmAction={() => onClose()}
        handleCancelAction={() => {
          setCancelModalOpen(false);
        }}
      />
    </>
  );
};
